<template>
    <div>
        <st-data-table
            :items="rows"
            :fields="fields"
            :actions="actions"
            :modelPresenter="presenter"
            @edit="onEdit"
            @delete="onDelete"
            responsive="sm"
            hover
        >
        </st-data-table>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { DocumentTemplateModel } from '../document-template-model';

    const { fields } = DocumentTemplateModel;

    export default {
        name: 'DocumentTemplateListTable',
        data() {
            return {
                presenter: DocumentTemplateModel.presenter,
            };
        },
        computed: {
            ...mapGetters({
                rows: 'documentTemplate/list/rows',
                documentTemplatePermissions: 'documentTemplate/list/documentTemplatePermissions',
            }),
            fields() {
                return [
                    fields.name,
                    fields.created_date,
                ];
            },
            actions() {
                return [
                    {
                        name: 'edit',
                        icon: 'edit',
                        tooltipText: this.$t('GENERAL.ACTIONS.EDIT'),
                        customIcon: false,
                        type: 'primary',
                        permission: this.documentTemplatePermissions.hasPermissionToEdit
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                        tooltipText: this.$t('GENERAL.ACTIONS.DELETE'),
                        customIcon: false,
                        type: 'primary',
                        permission: this.documentTemplatePermissions.hasPermissionToDestroy
                    }
                ]
            }
        },
        methods: {
            ...mapActions({
                deleteRecord: 'documentTemplate/form/remove',
            }),
            async onEdit(data) {
                if (!data?.item?.id) return;
                this.$router.push({
                    name: 'documentTemplateEdit',
                    params: {
                        id: data.item.id,
                    },
                });
            },
            async onDelete(data) {
                await this.deleteRecord(data.item.id);
            },
        },
    };
</script>
